import React from "react";

const FAQ = ({ theme }) => {
  const sectionBg = theme === "dark" ? "bg-[#0e1521]" : "bg-gray-50";
  const cardBg = theme === "dark" ? "bg-[#1e2b3a] text-white" : "bg-white text-black";

  const faqs = [
    {
      q: "📡 What hardware do I need?",
      a: "Just our plug-and-play OBD device or dashcam depending on the plan you choose."
    },
    {
      q: "🔌 Can I integrate this with my ERP?",
      a: "Yes, we provide custom integration support for enterprise plans."
    },
    {
      q: "🔒 Is video storage secure?",
      a: "All dashcam data is encrypted and stored on cloud infrastructure."
    },
  ];

  return (
    <section id="faq" className={`${sectionBg} w-full py-16 px-4`}>
      <div className="max-w-2xl mx-auto">
        <h2 className="text-3xl font-semibold text-center mb-10">Frequently Asked Questions</h2>
        <div className="space-y-3">
          {faqs.map((item, idx) => (
            <details key={idx} className={`${cardBg} p-4 rounded shadow transition-all`}>
              <summary className="font-medium cursor-pointer">{item.q}</summary>
              <p className="pt-2 text-sm">{item.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;